export const INVALID_DICTIONARY_NAME_ERROR =
  "Dictionary name must not contain the following invalid characters: /\\:*?\"<>|'";
export const BLANK_DICTIONARY_NAME_ERROR = "Dictionary name must not be blank";
export const DICTIONARY_NAME_DUPLICATE_ERROR =
  "A dictionary with this name already exists";

export const BLANK_CATEGORY_NAME_ERROR = "Category name can't be empty";
export const CATEGORY_NAME_DUPLICATE_ERROR =
  "A category with this name already exists";

export const saveButtonError =
  "You can't save the Ignore List as there are validation errors. You'll see an \"i\" icon against the category or term below flagging specific issue(s). Fix those first.";

export const documentBy = {
  theme: "theme",
  content: "content",
};

export const ACTION_BUTTONS_WIDTH = 82;
export const ACTION_BUTTONS_HEIGHT = 44;

// Placements of action buttons
export const PLACEMENTS = {
  LEFT: "left",
  RIGHT: "right",
  BOTTOM: "bottom",
  TOP: "top",
};

// SS/LS keys
export const DISCOVERY_SHRED_TO_EXCEL_LS_KEY = "discovery-shred-to-excel";

export const FILTER_TYPES = {
  GAPS_RELATIVE_TO_A_REFERENCE_DOC: "GAPS_RELATIVE_TO_A_REFERENCE_DOC",
  ALIGNMENT_ACROSS_DOCS: "ALIGNMENT_ACROSS_DOCS",
  PARTIAL_ALIGNMENT_ACROSS_DOCS: "PARTIAL_ALIGNMENT_ACROSS_DOCS",
  UNIQUE_REFERENCES_ACROSS_DOCS: "UNIQUE_REFERENCE_ACROSS_DOCS",
};

export const getFilterDescription = (filterType) => {
  switch (filterType) {
    case FILTER_TYPES.GAPS_RELATIVE_TO_A_REFERENCE_DOC:
      return "Gaps relative to a single doc";
    case FILTER_TYPES.ALIGNMENT_ACROSS_DOCS:
      return "Full alignment across docs";
    case FILTER_TYPES.PARTIAL_ALIGNMENT_ACROSS_DOCS:
      return "Partial alignment across docs";
    case FILTER_TYPES.UNIQUE_REFERENCES_ACROSS_DOCS:
      return "Unique references across docs";
    default:
      return "Wrong filter type";
  }
};
